export enum PromptRoleEnum {
  User = 'user',
  Assistant = 'assistant',
  system = 'system',
}
